import {
  Bell,
  AlertTriangle,
  CalendarDays,
  Users,
  Clock,
  type LucideIcon,
} from 'lucide-react';

export const COMUNICADO_TIPOS = ['AVISO', 'URGENTE', 'EVENTO', 'REUNIAO', 'LEMBRETE'] as const;
export type ComunicadoTipo = (typeof COMUNICADO_TIPOS)[number];

export const COMUNICADO_TIPO_COLORS: Record<string, { bg: string; color: string; border: string }> = {
  AVISO: { bg: '#fef3c7', color: '#d97706', border: '#fde68a' },
  URGENTE: { bg: '#fee2e2', color: '#dc2626', border: '#fecaca' },
  EVENTO: { bg: '#f3e8ff', color: '#7c3aed', border: '#e9d5ff' },
  REUNIAO: { bg: '#dcfce7', color: '#166534', border: '#bbf7d0' },
  LEMBRETE: { bg: '#dbeafe', color: '#2563eb', border: '#bfdbfe' },
};

export const COMUNICADO_TIPO_ICON: Record<
  ComunicadoTipo,
  { Icon: LucideIcon; label: string }
> = {
  AVISO: { Icon: Bell, label: 'Avisos' },
  URGENTE: { Icon: AlertTriangle, label: 'Urgentes' },
  EVENTO: { Icon: CalendarDays, label: 'Eventos' },
  REUNIAO: { Icon: Users, label: 'Reuniões' },
  LEMBRETE: { Icon: Clock, label: 'Lembretes' },
};

export const DESTINATARIO_LABEL: Record<string, string> = {
  TODOS: 'Toda a Comunidade',
  COMUNIDADE: 'Toda a Comunidade',
  DIRETORES_EQUIPE: 'Direção & Equipe',
  ESCOLA: 'Direção & Equipe',
  PROFESSORES: 'Professores',
  RESPONSAVEIS: 'Pais & Responsáveis',
  FAMILIAS: 'Pais & Responsáveis',
  ALUNOS: 'Alunos',
  SERIE: 'Série / Ano',
  TURMA: 'Turma Específica',
};

export const DESTINATARIO_LABEL_LONG: Record<string, string> = {
  TODOS: 'Toda a Comunidade Escolar & Rede',
  COMUNIDADE: 'Toda a Comunidade Escolar & Rede',
  DIRETORES_EQUIPE: 'Diretores, Coordenadores e Equipe Gestora',
  ESCOLA: 'Direção e Equipe Escolar',
  PROFESSORES: 'Corpo Docente e Professores',
  RESPONSAVEIS: 'Pais e Responsáveis Legais das Famílias',
  FAMILIAS: 'Pais e Responsáveis Legais das Famílias',
  ALUNOS: 'Estudantes e Alunos Matriculados',
  SERIE: 'Série / Ano Escolar Específico',
  TURMA: 'Turma Específica',
};
